import type { StateCreator } from 'zustand/vanilla';

import type { Space } from '@/features/spaces/interfaces/space.interface';
import type { WorkspaceStore } from '../../store';

export interface WorkspacePrivateAction {
  /**
   * Store the full private Space object for the current user.
   * The user store owns privateSpaceId (string); this store owns the full entity
   * for rich selectors (spaceType, isPrivateSpace, etc.).
   * Called during login / initialization when the user's personal space is resolved.
   */
  setPrivateSpace: (space: Space) => void;

  /**
   * Clear the private space to undefined.
   * Called on logout or when the user's personal space is invalidated.
   */
  clearPrivateSpace: () => void;
}

export const createPrivateSlice: StateCreator<WorkspaceStore, [['zustand/devtools', never]], [], WorkspacePrivateAction> = (set) => ({
  setPrivateSpace: (space: Space) => {
    set({ privateSpace: space });
  },

  clearPrivateSpace: () => {
    set({ privateSpace: undefined });
  },
});
